/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_FAIL, CVE_ESTATUS_TERCERO, GENERAL_TABLE } from '../../app/constantes';
import { getFacturacionTercerosRegistrados } from '../../services/cobro';
import { appState, setAlert } from '../../slices/appSlice';
import { catalogosServiceState, getCatalogoDocumentosTerceros } from '../../slices/catalogosServiceSlice';
import { getTips } from '../../services/catalogos';
import GeneralTable from '../generales/generalTable';
import ModalDatosFiscalesTerceros from './modalPagoTerceros';

export default function PagosTercero({convocatoria, idEntidad}) {
    const dispatch = useDispatch()
    const appSt = useSelector(appState)
    const catalogosSt = useSelector(catalogosServiceState)

    const [terceros, setTerceros] = useState(false)
    const [tableFormat, setTableFormat] = useState(null)
    const [tableActions, setTableActions] = useState(null)
    const [tipoDireccion, setTipoDireccion] = useState(null)
    const [modalData, setModalData] = useState({
        show: false,
        data: null
    })
    

    const getData = async () => {
        try {
            const resp = await getFacturacionTercerosRegistrados({
                ...appSt.serviceData,
                idEntidad: convocatoria ? convocatoria.idEntidad : idEntidad
            })
            if (resp && resp.payload && resp.payload.length > 0) {
                setTerceros(resp.payload)
            }
            if (!tipoDireccion) {
                const respTipo = await getTips({
                    ...appSt.serviceData,
                    claveCatalogo: "tipoDireccion",
                    clave: "TERCERO"
                })
                setTipoDireccion(respTipo.payload)
            }
        } catch (error) {
            console.error(error)
            dispatch(setAlert({
                show: true,
                message: 'Error al consultar información',
                type: ALERT_FAIL
            }))
        }
    }

    
    const editItem = async (item) => {
        setModalData({
            show: true,
            data: item
        })
    }

    const canEdit = (item) => {
        return item.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.rechazada || item.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.registrado
    }

    useEffect(() => {
        setTableFormat([
            {
                label: 'RFC',
                key: 'rfcTerceros',
                orden: 1
            },
            {
                label: 'Razon Social',
                key: 'razonSocialTercero',
                orden: 2
            },
            {
                label: 'Estatus',
                key: 'descEstatusFacturaTercero',
                orden: 3
            },
            {
                label: 'Observaciones',
                key: 'observacionFacturaTercero',
                orden: 4
            },
            {
                label: 'Acciones',
                type: GENERAL_TABLE.columnTypes.actions,
                actions: [
                    {
                        type: GENERAL_TABLE.actionType.tooltipBtn,
                        tooltip: "Editar/Enviar a validar",
                        icon: <EditIcon />,
                        rule: (item) => canEdit(item),
                        action: (registro) => editItem(registro)
                    },
                    {
                        type: GENERAL_TABLE.actionType.tooltipBtn,
                        tooltip: "Ver",
                        icon: <EyeIcon />,
                        rule: (item) => !canEdit(item),
                        action: (registro) => editItem(registro)
                    },
                    // {
                    //     type: GENERAL_TABLE.actionType.tooltipBtn,
                    //     tooltip: "Eliminar",
                    //     icon: <DeleteIcon />,
                    //     action: (registro) => deleteItem(registro),
                    // },                    
                ],
                orden: 5
            },
        ])
        setTableActions([
            {
                type: GENERAL_TABLE.actionType.button,
                label: 'Agregar datos fiscales',
                action: () => editItem(null),
            },
        ])
        getData()
        if (!catalogosSt.documentosTercero) {
            dispatch(getCatalogoDocumentosTerceros(appSt.serviceData))
        }
    }, [])


    return (<div className="pagos-terceros">

        {!terceros && <div className='actions'>
            <button onClick={() => editItem(null)}>Agregar datos fiscales</button>
        </div>}
        
        {terceros && (
            <GeneralTable quickActions={tableActions} registros={terceros} headers={tableFormat} />
        )}

        <ModalDatosFiscalesTerceros idEntidad={idEntidad} modalData={modalData} setModalData={setModalData} tipoDireccion={tipoDireccion} refreshData={getData} />
    </div>)
}